import styled from 'styled-components';

export const LayoutStyled = styled.div``;
